export default __webpack_public_path__ + "static/media/banana-ltc-bnb.8eceb663.svg";